import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, reset, touch, focus } from 'redux-form';

import moment from 'moment';

import * as licenseLib from 'libs/licenseLib';
import * as licenseActions from 'modules/license';

import { LicenseEdit } from 'components';

const reduxFormName = 'licenseEdit';
class CtLicenseEdit extends PureComponent {
  constructor(props) {
    super(props);

    //this.checkFieldCount = 0;
    this.state = {
      onProgress: true,
      serviceNoError: false,
      durationLicenseError: false,
      timesLicenseError: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const { invalid, editSaveNow, setEditInvalid, setDisableSave, licenseInfo } = this.props;
    const { formStore } = nextProps;

    if (invalid !== nextProps.invalid && typeof setEditInvalid === 'function') {
      setEditInvalid(nextProps.invalid);
    }

    if (nextProps.editSaveNow && nextProps.editSaveNow !== editSaveNow) {
      if (nextProps.invalid) {
        if (typeof setDisableSave === 'function') {
          setDisableSave(true);
        }
        this.markFieldValidate(reduxFormName);
      } else {
        this.saveLicense();
      }
    }

    if (formStore && formStore.fields) {
      const errorType = ['syncErrors', 'syncWarnings', 'asyncErrors', 'asyncWarnings'];

      let anyError = false;
      for (const field in formStore.fields) {
        if (
          formStore.fields.hasOwnProperty(field) &&
          formStore.fields[field].touched &&
          formStore.fields[field].visited &&
          formStore.registeredFields[field] &&
          formStore.registeredFields[field].count > 0
        ) {
          for (let i = 0, l = errorType.length; i < l; i++) {
            if (formStore[errorType[i]] && formStore[errorType[i]][field]) {
              anyError = true;
              if (typeof setDisableSave === 'function') {
                setDisableSave(true);
              }
              break;
            }
          }

          const { licenseType, licenseCount, examLimitCount } = formStore.values;

          // 기간 라이센스 - 수량 체크 (사용한 라이센스 수량보다 적을 경우 저장 버튼 비활성화)
          if (licenseType === 2 && !!licenseCount && (licenseInfo.targetUsedCount > parseInt(licenseCount))) {
            this.setState({ durationLicenseError: true });
            anyError = true;
            setDisableSave(true);
            setEditInvalid(true);
          } else {
            this.setState({ durationLicenseError: false });
          }

          // 횟수 라이센스 - 훈련 횟수 체크
          if (licenseType === 4 && !!examLimitCount && licenseInfo.examUsedCount > examLimitCount) {
            this.setState({ timesLicenseError: true });
            anyError = true;
            setDisableSave(true);
            setEditInvalid(true);
          } else {
            this.setState({ timesLicenseError: false });
          }
        }
        if (anyError) {
          break;
        }
      }

      if (!anyError) {
        if (typeof setDisableSave === 'function') {
          setDisableSave(false);
        }
      }
    }
  }

  // serviceNoError 초기화
  onInitError = () => {
    this.setState({ serviceNoError: false });
  };

  markFieldValidate = formName => {
    const { dispatch, formStore } = this.props;

    if (formStore && formStore.registeredFields) {
      for (const field in formStore.registeredFields) {
        if (formStore.registeredFields.hasOwnProperty(field)) {
          if (formStore.registeredFields[field].count > 0) {
            dispatch(focus(formName, field));
            dispatch(touch(formName, field));
          }
        }
      }
    }
  };

  saveLicense = async () => {
    const { invalid, setEditOnProgress } = this.props;
    let serviceNoError = false;

    if (typeof setEditOnProgress === 'function') {
      setEditOnProgress(true);
    }
    this.setState({ onProgress: true });

    if (!this.props.invalid) {
      const {
        actionMode,
        isAuth,
        formStore,
        invalid,
        licenseInfo,
        LicenseActions,
        handleOnToggleEditModal
      } = this.props;

      let preparedParams = false;
      const params = {};
      if (formStore && formStore.values && formStore.registeredFields) {
        for (const field in formStore.registeredFields) {
          if (formStore.registeredFields.hasOwnProperty(field)) {
            if (formStore.registeredFields[field].count > 0) {
              if (typeof formStore.values[field] !== 'undefined' && formStore.values[field] !== licenseInfo[field]) {
                if (field === 'startDate') {
                  const startEpoch = moment(formStore.values[field])
                    .hour(0)
                    .minute(0)
                    .second(0)
                    .unix();
                  if (startEpoch !== formStore.values.startEpoch) {
                    params['startEpoch'] = startEpoch;
                  }
                } else if (field === 'endDate') {
                  const endEpoch = moment(formStore.values[field])
                    .hour(23)
                    .minute(59)
                    .second(59)
                    .unix();
                  if (endEpoch !== formStore.values.endEpoch) {
                    params['endEpoch'] = endEpoch;
                  }
                } else {
                  params[field] = formStore.values[field];
                  preparedParams = true;
                }
              }
            }
          }
        }

        if (actionMode !== 'edit') {
          params.licenseCount = formStore.values.licenseCount;
          params.licenseType = formStore.values.licenseType;
          params.startEpoch = moment(formStore.values.startDate)
            .hour(0)
            .minute(0)
            .second(0)
            .unix();
          preparedParams = true;
        } else {
          params.licenseNo = formStore.values.licenseNo;
        }

        if (isAuth === 2) {
          params.serviceNo = formStore.values.serviceNo;
        }
      }

      if (Object.keys(params).length > 0) {
        preparedParams = true;
      } else {
        preparedParams = false;
      }

      if (preparedParams) {
        //
        try {
          let respObj;
          if (actionMode === 'edit') {
            respObj = await LicenseActions.updateLicense(params);
          } else {
            respObj = await LicenseActions.addLicense(params);
          }

          if (respObj && respObj.status && respObj.status === 200 && respObj.data) {
            // 성공
            if (!!respObj.data.list) {
              // 새로고침
              LicenseActions.reloadLicense();
              handleOnToggleEditModal();
              // 서비스 넘버 에러
            } else if (!!respObj.data.error && !!respObj.data.error[0].errInfo) {
              if (respObj.data.error[0].errInfo === 'Required ServiceNo') {
                serviceNoError = true
              }
              // 버튼 로딩처리 제거
              setEditOnProgress(false);
            }
          } else {
            // 응답 오류
            console.log('실패');
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        // 업데이트 할 것이 없음
      }

      this.setState({ onProgress: false, serviceNoError: serviceNoError });
    } else {
      // invalid
    }
  };

  handleOnOpenEditModal = () => {
    const { setEditOnProgress } = this.props;

    if (typeof setEditOnProgress === 'function') {
      setEditOnProgress(false);
    }
    this.setState({ onProgress: false });
  };

  render() {
    const { onProgress, serviceNoError, durationLicenseError, timesLicenseError } = this.state;
    const { actionMode, isAuth, loginUser, formStore, invalid, licenseInfo, handleOnToggleEditModal } = this.props;
    const { onInitError, handleOnOpenEditModal, saveLicense } = this;

    return (
      <LicenseEdit
        actionMode={actionMode}
        loginUser={loginUser}
        isAuth={isAuth}
        onProgress={onProgress}
        formStore={formStore}
        invalid={invalid}
        licenseInfo={licenseInfo}
        saveLicense={saveLicense}
        serviceNoError={serviceNoError}
        onInitError={onInitError}
        handleOnOpenEditModal={handleOnOpenEditModal}
        handleOnToggleEditModal={handleOnToggleEditModal}
        durationLicenseError={durationLicenseError}
        timesLicenseError={timesLicenseError}
      />
    );
  }
}

CtLicenseEdit.propTypes = {};
CtLicenseEdit.defaultProps = {};

const mapStateToProps = (state, props) => {
  const { licenseInfo, actionMode } = props;

  const initValues = licenseInfo;
  if (actionMode === 'edit') {
    initValues.startDate = moment(licenseInfo.startEpoch * 1000);
    initValues.endDate = moment(licenseInfo.endEpoch * 1000);
  }

  return {
    initialValues: initValues,
    formStore: state.form[reduxFormName],
    isAuth: state.user.get('isAuth'),
    loginUser: state.user.get('user')
  };
};

const mapDispatchToProps = dispatch => ({
  LicenseActions: bindActionCreators(licenseActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: reduxFormName,
    enableReinitialize: true,
    touchOnChange: true
  })(CtLicenseEdit)
);



// WEBPACK FOOTER //
// ./src/script/containers/license/CtLicenseEdit.js